import React, { useState, useEffect } from "react";

/**
 * User avatar: shows the Google profile photo when available, otherwise falls
 * back to a gradient tile with the user's initial. Also falls back if the
 * image fails to load (e.g. expired/blocked photo URL).
 *
 * Pass sizing/rounding via `className` (e.g. "w-10 h-10 rounded-2xl").
 */
const Avatar = ({ user, className = "", textClassName = "" }) => {
  const [failed, setFailed] = useState(false);
  const photo = user?.picture;

  // Reset the error state if the user (or their photo) changes.
  useEffect(() => {
    setFailed(false);
  }, [photo]);

  const initial = (user?.name || user?.email || "U")[0]?.toUpperCase() || "U";

  if (photo && !failed) {
    return (
      <img
        src={photo}
        alt={user?.name || "User"}
        onError={() => setFailed(true)}
        referrerPolicy="no-referrer"
        className={`object-cover ${className}`}
      />
    );
  }

  return (
    <div
      className={`bg-accent-gradient flex items-center justify-center font-bold text-[#04121F] ${textClassName} ${className}`}
    >
      {initial}
    </div>
  );
};

export default Avatar;
